module.exports = __webpack_public_path__ + "img/down-arrow.c8792e17.svg";